import {
  reactQueryDelete,
  reactQueryGet,
  reactQueryPut,
} from "../helpers/backendRequestHelpers";
import { internalApi } from "../helpers/urlHelpers";

export interface CircleAiConversation {
  daily_brief_conversation: boolean;
  id: number;
  last_message_preview: string | null;
  project_id: string | null;
  title: string | null;
  updated_at: string;
  uuid: string;
}

export interface CircleAiConversationsListResponse {
  pagination: {
    page: number;
    per_page: number;
    total_count: number;
  };
  records: CircleAiConversation[];
}

const list = ({
  params = {},
}: {
  params?: {
    page?: number;
    per_page?: number;
    project_id?: string;
    query?: string;
  };
} = {}) =>
  reactQueryGet<CircleAiConversationsListResponse>(
    internalApi.circleAiConversations.list({ params }),
  );

const archive = ({ id }: { id: string }) =>
  reactQueryPut<void, never>(internalApi.circleAiConversations.archive({ id }));

interface UpdateConversationBody {
  project_id?: string | null;
  title?: string;
}

const update = ({
  id,
  title,
  projectId,
}: {
  id: string;
  projectId?: string | null;
  title?: string;
}) => {
  const body: UpdateConversationBody = {};
  if (title !== undefined) body.title = title;
  if (projectId !== undefined) body.project_id = projectId;

  return reactQueryPut<void, UpdateConversationBody>(
    internalApi.circleAiConversations.update({ id }),
    body,
  );
};

const destroy = ({ id }: { id: string }) =>
  reactQueryDelete<void, never>(
    internalApi.circleAiConversations.destroy({ id }),
  );

export const circleAiConversationsApi = {
  list,
  archive,
  update,
  destroy,
};
